/**
 * Scrolling ticker banner above the Pick-n-Mix Machine builder. Shows the
 * active bag's contents ("PEACH ×3") plus a status item (oz to go, or
 * ready-to-seal with the total), falling back to idle brand copy when the
 * bag is empty. Rebuilds whenever the mix state changes; the track is
 * rendered twice back-to-back so a plain -50% translateX loops seamlessly
 * (CSS handles the animation itself, in section-pick-your-mix.css.liquid).
 */
(function () {
  function init() {
    const root = document.querySelector('[data-ticker]');
    const mixBuilder = document.querySelector('mix-builder');
    if (!root || !mixBuilder || !mixBuilder.state) return;

    const track = root.querySelector('[data-ticker-track]');
    const pauseBtn = root.querySelector('[data-ticker-pause]');
    const state = mixBuilder.state;
    const C = window.MIX_BUILDER_CONSTANTS || { BAG_MIN_OZ: 8 };

    function buildItems() {
      const bag = state.activeBag;
      const items = Object.entries(bag.items).map(([id, oz]) => {
        const candy = state.candyById[id];
        return (candy ? candy.name : id).toUpperCase() + ' ×' + oz;
      });
      const total = state.bagWeight(state.activeBagIndex);
      const price = state.bagPrice(state.activeBagIndex);
      if (items.length) {
        if (state.canSeal()) {
          items.push('READY TO SEAL · ' + total + ' OZ · $' + price.toFixed(2));
        } else {
          const need = state.ozNeededForFirstBag();
          items.push(need + ' OZ TO GO · ' + state.minOz() + ' OZ MINIMUM ON YOUR FIRST BAG');
        }
      }
      if (!items.length) {
        items.push(state.mode === 'halloween' ? 'HALLOWEEN PICK-N-MIX' : 'PICK-N-MIX MACHINE', '$2.35 AN OUNCE', state.minOz() + ' OZ MINIMUM ON YOUR FIRST BAG');
      }
      return items;
    }

    function render() {
      const items = buildItems();
      const html = items.map((t) => '<span class="ticker__i" data-t="' + t.replace(/"/g, '&quot;') + '"></span>').join('');
      // duplicated so translate(-50%) in the CSS keyframe loops with no gap
      track.innerHTML = html + html;
    }

    render();
    state.addEventListener('change', render);

    if (pauseBtn) {
      pauseBtn.addEventListener('click', () => {
        const paused = root.classList.toggle('is-paused');
        pauseBtn.setAttribute('aria-pressed', String(paused));
        pauseBtn.textContent = paused ? 'Resume ticker' : 'Pause ticker';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
